import React from "react";

const WarningIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M14.7081 7.29454L8.705 1.29079C8.51764 1.10454 8.26419 1 8 1C7.73582 1 7.48237 1.10454 7.295 1.29079L1.295 7.29454C1.10875 7.48191 1.00421 7.73536 1.00421 7.99954C1.00421 8.26373 1.10875 8.51718 1.295 8.70454L7.29813 14.7083C7.48549 14.8945 7.73894 14.9991 8.00313 14.9991C8.26732 14.9991 8.52077 14.8945 8.70813 14.7083L14.7113 8.70454C14.8975 8.51718 15.002 8.26373 15.002 7.99954C15.002 7.73536 14.8975 7.48191 14.7113 7.29454H14.7081ZM7.5 4.99954C7.5 4.86693 7.55268 4.73976 7.64645 4.64599C7.74022 4.55222 7.8674 4.49954 8 4.49954C8.13261 4.49954 8.25979 4.55222 8.35356 4.64599C8.44733 4.73976 8.5 4.86693 8.5 4.99954V8.49954C8.5 8.63215 8.44733 8.75933 8.35356 8.8531C8.25979 8.94686 8.13261 8.99954 8 8.99954C7.8674 8.99954 7.74022 8.94686 7.64645 8.8531C7.55268 8.75933 7.5 8.63215 7.5 8.49954V4.99954ZM8 11.4995C7.85167 11.4995 7.70666 11.4556 7.58333 11.3731C7.45999 11.2907 7.36386 11.1736 7.30709 11.0366C7.25033 10.8995 7.23548 10.7487 7.26442 10.6032C7.29335 10.4577 7.36478 10.3241 7.46967 10.2192C7.57456 10.1143 7.7082 10.0429 7.85369 10.014C7.99917 9.98501 8.14997 9.99987 8.28702 10.0566C8.42406 10.1134 8.54119 10.2095 8.62361 10.3329C8.70602 10.4562 8.75 10.6012 8.75 10.7495C8.75 10.9485 8.67099 11.1392 8.53033 11.2799C8.38968 11.4205 8.19892 11.4995 8 11.4995Z"
      fill="#C58300"
    />
  </svg>
);

export default WarningIcon;
